import { render } from "./TaskListItem.vue?vue&type=template&id=61b94824&scoped=true"
import script from "./TaskListItem.vue?vue&type=script&lang=js"
export * from "./TaskListItem.vue?vue&type=script&lang=js"

import "./TaskListItem.vue?vue&type=style&index=0&id=61b94824&lang=scss"
import "./TaskListItem.vue?vue&type=style&index=1&id=61b94824&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b94824"]])

export default __exports__